import dayjs from 'dayjs';

// Os sensores publicam a hora em UTC; tudo é mostrado no horário de Brasília.
const TZ = 'America/Sao_Paulo';

export const todayBr = () => new Date().toLocaleDateString('en-CA', { timeZone: TZ }); // AAAA-MM-DD

export const daysAgoBr = (n: number) => dayjs(todayBr()).subtract(n, 'day').format('YYYY-MM-DD');

export const formatDateTime = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleString('pt-BR', {
        timeZone: TZ,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    : '—';

export const formatDay = (day: string) => dayjs(day).format('DD/MM');

export const formatDuration = (seconds: number) => {
  if (!seconds) return '0 s';
  if (seconds < 60) return `${seconds.toFixed(1).replace('.', ',')} s`;
  const min = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return min < 60 ? `${min} min ${s} s` : `${Math.floor(min / 60)} h ${min % 60} min`;
};

export const formatNumber = (n: number) => n.toLocaleString('pt-BR');

export const WEEKDAYS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']; // ISO 1..7

export type Period = { from: string; to: string };

export const PERIOD_PRESETS: { label: string; days: number }[] = [
  { label: 'Hoje', days: 0 },
  { label: '7 dias', days: 6 },
  { label: '30 dias', days: 29 },
  { label: '90 dias', days: 89 },
];
